{
    "filterConfig": {
    "filterFields": [
        {
            "name": "VESSEL_NAME_CONTAINS",
            "displayLabel": "Vessel Name",
            "dataType": "STRING",
            "supportedOperators": ["EQ"],
            "operatorToFilterMap": {
                "EQ": "VESSEL_NAME_CONTAINS"
            }

        },
        {
          "name": "VIA_NO_CONTAINS",
          "displayLabel": "VIA No",
          "dataType": "STRING",
          "supportedOperators": ["EQ"],
           "operatorToFilterMap": {
            "EQ": "VIA_NO_CONTAINS"
            }
        },
        {
            "name": "IGM_NO_EQUALS",
            "displayLabel": "IGM No",
            "dataType": "STRING",
            "supportedOperators": ["EQ"],
             "operatorToFilterMap": {
              "EQ": "IGM_NO_EQUALS"
            }
        },
        {
        "name": "IS_ACTIVE",
        "displayLabel": "Active",
        "dataType": "BOOLEAN",
        "operatorToFilterMap": {
          "EQ": "IS_ACTIVE"
        }
      }
    ],
        "useNewContract": true

    },


    "searchBarConfig": {
    "placeHolder": "Search vessel porte by name",
    "filters": [
      {
        "name": "VESSEL_NAME_CONTAINS",
        "alias": "vessel_name"
      }
    ]
  },


    "vesselTableConfig": {
        "columns": [
        {
            "fieldName": "vesselName",
            "displayName": "Vessel Name",
            "dataType": "STRING"
        },
        {
            "fieldName": "viaNo",
            "displayName": "Via No",
            "dataType": "STRING"
        },
        {
            "fieldName": "igmNo",
            "displayName": "IGM No",
            "dataType": "STRING"
        },
        {
            "fieldName": "portName",
            "displayName": "Port",
            "dataType": "STRING"
        },
        {
            "fieldName": "berthDate",
            "displayName": "Berth Date",
            "dataType": "STRING"
        },
        {
            "fieldName": "cutOffDate",
            "displayName": "Cut Off Date",
            "dataType": "STRING"
        },
        {
            "fieldName": "modifiedBy",
            "dbName": "modified_by",
            "displayName": "Modified By",
            "dataType": "STRING",
            "styleConfig": {
              "type": "user-avatar"
            }
          },
          {
            "fieldName": "modifiedDate",
            "dbName": "modified_date",
            "displayName": "Modified Date",
            "dataType": "DATETIME",
            "sortable": true
          }
    ]
    },

    "itemTableConfig": {
        "columns": [
        {
            "fieldName": "igmNo",
            "displayName": "IGM No",
            "dataType": "STRING"
        },
        {
            "fieldName": "itemNo",
            "displayName": "Item No",
            "dataType": "STRING"
        },
        {
            "fieldName": "subItemNo",
            "displayName": "Sub Item No",
            "dataType": "STRING"
        },
        {
            "fieldName": "blNo",
            "displayName": "MBL No",
            "dataType": "STRING"
        },
        {
            "fieldName": "hblNo",
            "displayName": "HBL No",
            "dataType": "STRING"
        },
        {
            "fieldName": "importType",
            "displayName": "Import Type",
            "dataType": "STRING"
        },
        {
            "fieldName": "dpd",
            "displayName": "DPD",
            "dataType": "BOOLEAN"
        },
        {
            "fieldName": "numberOfPackages",
            "displayName": "NOP",
            "dataType": "STRING"
        },
        {
            "fieldName": "grossWeight",
            "displayName": "Gross Weight",
            "dataType": "STRING"
        }
    ]
    }
}